<form #form="ngForm" class="container-form" novalidate>
    <!--Options-->
    <div class="row container-form-options">
        <div class="col-12">
            <button type="button" class="btn btn-success mr-2" (click)="save()" id="btnSave">
                <i class="fas fa-check" aria-hidden="true"></i> Salvar
            </button>
                <button type="button" class="btn btn-light" (click)="cancel()">
                <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
            </button>
        </div>
    </div>

    <!--Content-->
    <div class="row container-form-content" *ngIf="entity">
        <div class="col-12">
            <div class="row">
                <div class="form-group col-12 col-md-3 col-xl-2">
                    <label for="codigoIntegracaoErp" class="col-form-label">Código ERP</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.codigoIntegracaoErp" name="codigoIntegracaoErp" id="codigoIntegracaoErp"
                        #codigoIntegracaoErp="ngModel" maxlength="50" [autofocus]="true">
                    <p class="form-text text-muted">Código da unidade no seu sistema ERP</p>
                    <sgt-form-control-error
                        *ngIf="codigoIntegracaoErp.errors && codigoIntegracaoErp.errors.maxlength"
                        msgError="O código deve ter no máximo 50 caracteres">
                    </sgt-form-control-error>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12">
                    <label for="nome" class="col-form-label">Nome</label>
                    <input type="text" class="form-control " [(ngModel)]="entity.nome" name="nome" id="nome"
                        #nome="ngModel" required="required" maxlength="255">
                    <sgt-form-control-error
                        *ngIf="nome.errors && nome.errors.required && nome.dirty"
                        msgError="O nome é obrigatório">
                    </sgt-form-control-error>
                    <sgt-form-control-error
                        *ngIf="nome.errors && nome.errors.maxlength"
                        msgError="O nome deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 col-md-4 col-xl-3">
                    <label for="fatorConversaoUnidade" class="col-form-label">Fator Conversão</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">1 {{entity.codigoIntegracaoErp}} =</span>
                        </div>                        
                        <sgt-decimal [(ngModel)]="entity.fatorConversaoUnidade" name="fatorConversaoUnidade" id="fatorConversaoUnidade"
                            #fatorConversaoUnidade="ngModel" [ngControl]="fatorConversaoUnidade">
                        </sgt-decimal>
                        <div class="input-group-append">
                            <span class="input-group-text">UN</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
